import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import _ from 'lodash'
import RasterLayer from '@/components/map/mapbox-layers/RasterLayer.vue'
import { getFileBlob } from '@/services/files.service'
import { useStore } from 'vuex'
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { Orthophoto, PointCoordinates } from '@/interfaces/misc.interface'
import { useGeneralStore } from '@/pinia'
import { Layer } from 'mapbox-gl'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'LayerOrthophotoFloor',
  props: {
    layerId: {},
    before: {}
  },
  setup(__props: any) {



const piniaStore = useGeneralStore()
const store = useStore()
const { t } = useI18n()

const isMapviewShowing = computed(() => store.getters['isMapviewShowing'])
// const currentDrawingTransparency = computed(() => store.state.planview.currentDrawingTransparency)
const fetchedSources = ref<
  { orthophotoId: string; type: string; url: string; coordinates: PointCoordinates[] }[]
>([])
const filteredOrthophotos = computed(() => piniaStore.filteredOrthophotos)
const sources = ref<{ type: string; url: string; coordinates: PointCoordinates[] }[]>([])

function layerOrthophotoStyle(index: number): Layer {
  return {
    id: getOrthophotoLayerId(index),
    source: getOrthophotoSourceId(index),
    type: 'raster',
    paint: {
      'raster-opacity':
        filteredOrthophotos.value.filter((orthophoto) => orthophoto.visible).length === 1
          ? 1 // currentDrawingTransparency.value
          : 0.6
    }
  }
}
function getOrthophotoLayerId(index: number) {
  return `layer-orthophoto-floor-${index}`
}
function getOrthophotoSourceId(index: number) {
  return `source-orthophoto-floor-${index}`
}
async function getOrthophoto(orthophoto: Orthophoto) {
  try {
    const endpoint = `/documents/${orthophoto.storageFileName}`
    const orthophotoFile = await getFileBlob(endpoint)
    const url = window.URL.createObjectURL(orthophotoFile?.data)
    const source = {
      type: 'image',
      url,
      coordinates: [
        orthophoto.northWest,
        orthophoto.northEast,
        orthophoto.southEast,
        orthophoto.southWest
      ]
    }
    sources.value.push(source)
    fetchedSources.value.push({
      orthophotoId: orthophoto.id,
      type: source.type,
      url: source.url,
      coordinates: source.coordinates
    })
  } catch (e) {
    updateFilteredOrthophotos(orthophoto.id)
    store.commit('setInfoMessage', {
      type: 'error',
      message: t('general__data__orthophoto-download-failed')
    })
    console.error(e)
  }
}
function hideFilteredOrthophotos() {
  const orthophotoLayers = filteredOrthophotos.value
  orthophotoLayers.forEach((orthophoto) => {
    orthophoto.visible = false
  })
  piniaStore.setFilteredOrthophotos(orthophotoLayers)
}
function loadOrthophoto(orthophoto: Orthophoto) {
  const existingSource = fetchedSources.value.find(
    (source) => source.orthophotoId === orthophoto.id
  )
  if (!existingSource) return
  const source = {
    type: existingSource.type,
    url: existingSource.url,
    coordinates: existingSource.coordinates
  }
  sources.value.push(source)
}

function updateFilteredOrthophotos(id) {
  const orthophotoLayers = filteredOrthophotos.value
  const index = orthophotoLayers.findIndex((layer) => layer.id === id)
  if (index === -1) return
  orthophotoLayers[index].visible = !orthophotoLayers[index].visible
  piniaStore.setFilteredOrthophotos(orthophotoLayers)
}

watch(isMapviewShowing, () => {
  if (isMapviewShowing.value) hideFilteredOrthophotos()
})
watch(
  () => _.cloneDeep(filteredOrthophotos.value),
  (newOrthophotos) => {
    sources.value = []
    if (!newOrthophotos.length || !newOrthophotos.some((orthophoto) => orthophoto.visible)) return
    newOrthophotos.forEach((orthophoto) => {
      if (orthophoto.visible && orthophoto.tiledLayerUri === undefined) {
        if (fetchedSources.value.find((source) => source.orthophotoId === orthophoto.id)) {
          loadOrthophoto(orthophoto)
          return
        }
        getOrthophoto(orthophoto)
        return
      }
      const fetchedSource = fetchedSources.value.find(
        (source) => source.orthophotoId === orthophoto.id
      )
      const index = sources.value.findIndex((source) => source.url === fetchedSource?.url)
      if (index === -1) return
      sources.value.splice(index, 1)
    })
  },
  { immediate: true }
)

onBeforeUnmount(() => {
  if (fetchedSources.value.length)
    fetchedSources.value.forEach((source) => window.URL.revokeObjectURL(source.url))
})

return (_ctx: any,_cache: any) => {
  return (sources.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sources.value, (source, index) => {
          return (_openBlock(), _createBlock(RasterLayer, {
            key: index,
            before: _ctx.before,
            layer: layerOrthophotoStyle(index),
            layerId: getOrthophotoLayerId(index),
            sourceId: getOrthophotoSourceId(index),
            source: source
          }, null, 8, ["before", "layer", "layerId", "sourceId", "source"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})